import { WritableDraft } from 'immer/dist/internal';
import { SRP_PROPERTY } from '../constants';
import type { FilterPropertyV2 } from '../types';

export const togglePropertySelection = (
    filters: WritableDraft<FilterPropertyV2>, filterProperty: string, value: number,
) => {
    const isDepartments = filterProperty === SRP_PROPERTY.departments;
    const isPrice = filterProperty === (SRP_PROPERTY.priceMin || SRP_PROPERTY.priceMax);

    if (isDepartments) {
        if (filters.active?.[filterProperty] === value) {
            delete filters.active[filterProperty];
        } else {
            filters.active[filterProperty] = value;
        }
    } else if (isPrice) {
        filters.active[filterProperty] = value;
    } else {
        const selectedFilterValues = filters.active?.[filterProperty] as number[] || [];

        if (selectedFilterValues.includes(value)) {
            filters.active[filterProperty] = selectedFilterValues.filter(item => item !== value);
        } else {
            filters.active[filterProperty] = [...selectedFilterValues, value];
        }
    }

    if (filters.active?.[filterProperty] && (filters.active[filterProperty] as number[]).length === 0) {
        delete filters.active[filterProperty];
    }
};
